module.exports = __webpack_public_path__ + "img/maximize-white.1fce4e71.svg";